export const PAGE_TYPE = Object.freeze({
    ABOUT: 'about',
    ASSOCIATION: 'association',
    ATTRIBUTE: 'attribute',
    BROWSE: 'browse',
    CART: 'cart',
    CHECKOUT: 'checkout',
    CHECKOUT_CONFIRMATION: 'checkoutConfirmation',
    COLLECTION: 'collection',
    CREATOR: 'creator',
    DEALER: 'dealer',
    FAVORITES: 'favorites',
    HOME: 'home',
    INVOICE: 'invoice',
    LOCATION: 'location',
    MATERIAL: 'material',
    MESSAGE_CENTER: 'messageCenter',
    METAL: 'metal',
    ORDER_MANAGER: 'orderManager',
    ORDER_LOOKUP: 'orderLookup',
    ORIGIN: 'origin',
    PDP: 'pdp',
    PERIOD: 'period',
    RECOGNIZED_DEALERS: 'recognized_dealers',
    SEARCH: 'search',
    SECTION: 'section',
    SOURCING: 'sourcing',
    STONE: 'stone',
    STYLE: 'style',
    TECHNIQUE: 'technique',
    TRADE_PROFILE: 'trade',
    TRADE_REWARDS: 'tradeRewards',
    WORKSPACE: 'workspace',
    BUY: 'buy',
});

export const BROWSE_TYPES = Object.freeze([
    PAGE_TYPE.ASSOCIATION,
    PAGE_TYPE.ATTRIBUTE,
    PAGE_TYPE.BROWSE,
    PAGE_TYPE.COLLECTION,
    PAGE_TYPE.CREATOR,
    PAGE_TYPE.LOCATION,
    PAGE_TYPE.MATERIAL,
    PAGE_TYPE.METAL,
    PAGE_TYPE.ORIGIN,
    PAGE_TYPE.PERIOD,
    PAGE_TYPE.RECOGNIZED_DEALERS,
    PAGE_TYPE.SECTION,
    PAGE_TYPE.STONE,
    PAGE_TYPE.STYLE,
    PAGE_TYPE.TECHNIQUE,
    PAGE_TYPE.BUY,
]);
